import React, { useState } from 'react';
import jsPDF from 'jspdf';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiPrinter, FiFileText, FiCheck, FiLoader } = FiIcons;

const ReportExporter = ({ markdownReport, companyName, reportRef }) => {
  const [status, setStatus] = useState({});

  const setS = (key, val) => setStatus(prev => ({ ...prev, [key]: val }));

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadTXT = () => {
    setS('txt', 'loading');
    try {
      const blob = new Blob([markdownReport], { type: 'text/markdown' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${(companyName || 'Entity').replace(/\s+/g, '_')}_Credit_Memo.md`;
      a.click();
      URL.revokeObjectURL(url);
      setS('txt', 'success');
      setTimeout(() => setS('txt', null), 3000);
    } catch {
      setS('txt', 'error');
    }
  };

  const handleDownloadPDF = () => {
    setS('pdf', 'loading');
    try {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 15;
      const maxWidth = pageWidth - margin * 2;

      doc.setFillColor(6, 20, 27);
      doc.rect(0, 0, pageWidth, 297, 'F');

      doc.setFontSize(18);
      doc.setTextColor(46, 204, 113);
      doc.setFont('helvetica', 'bold');
      doc.text('CREDIT MEMORANDUM', margin, 20);

      doc.setFontSize(11);
      doc.setTextColor(200, 200, 200);
      doc.setFont('helvetica', 'normal');
      doc.text(`Entity: ${companyName || 'N/A'}`, margin, 30);
      doc.text(`Generated: ${new Date().toLocaleDateString()}`, margin, 37);
      doc.text('Source: CreditSonar Autonomous OSINT Engine', margin, 44);

      doc.setDrawColor(46, 204, 113);
      doc.setLineWidth(0.5);
      doc.line(margin, 48, pageWidth - margin, 48);

      // Strip markdown for PDF text
      const plainText = markdownReport
        .replace(/#{1,6}\s/g, '')
        .replace(/\*\*(.*?)\*\*/g, '$1')
        .replace(/\*(.*?)\*/g, '$1')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/`{1,3}[^`]*`{1,3}/g, '')
        .replace(/^\s*[-*+]\s/gm, '• ')
        .replace(/\|[^\n]+\|/g, '')
        .replace(/^-{3,}$/gm, '---')
        .trim();

      doc.setFontSize(8.5);
      doc.setTextColor(180, 180, 180);
      doc.setFont('courier', 'normal');

      const lines = doc.splitTextToSize(plainText, maxWidth);
      let y = 56;
      const lineH = 4.5;
      const pageH = 297 - 15;

      lines.forEach(line => {
        if (y + lineH > pageH) {
          doc.addPage();
          doc.setFillColor(6, 20, 27);
          doc.rect(0, 0, pageWidth, 297, 'F');
          y = 15;
        }
        doc.text(line, margin, y);
        y += lineH;
      });

      doc.save(`${(companyName || 'Entity').replace(/\s+/g, '_')}_Credit_Memo.pdf`);
      setS('pdf', 'success');
      setTimeout(() => setS('pdf', null), 3000);
    } catch (err) {
      console.error(err);
      setS('pdf', 'error');
    }
  };

  const BtnIcon = ({ type }) => {
    if (status[type] === 'loading') return <SafeIcon icon={FiLoader} className="animate-spin text-xs" />;
    if (status[type] === 'success') return <SafeIcon icon={FiCheck} className="text-xs text-sonar-green" />;
    return null;
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button
        onClick={handleDownloadTXT}
        className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-lg border border-sonar-border text-slate-300 hover:border-sonar-green hover:text-sonar-green transition-all font-mono"
      >
        <SafeIcon icon={FiFileText} />
        Download .md
        <BtnIcon type="txt" />
      </button>

      <button
        onClick={handleDownloadPDF}
        className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-lg border border-sonar-border text-slate-300 hover:border-red-400 hover:text-red-400 transition-all font-mono"
      >
        <SafeIcon icon={FiDownload} />
        Download PDF
        <BtnIcon type="pdf" />
      </button>

      <button
        onClick={handlePrint}
        className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-lg bg-sonar-green text-black hover:bg-sonar-green-glow transition-all font-mono glow-border"
      >
        <SafeIcon icon={FiPrinter} />
        Print / Save
      </button>
    </div>
  );
};

export default ReportExporter;